module.exports = __WEBPACK_EXTERNAL_MODULE__7010__;